export interface Bonus {
  title: string
  description: string
  price: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Schede Operative Stampabili',
    description: 'Guida pratica per usare schede di scienze pronte da stampare, senza preparazione',
    price: '19 €',
    image: 'https://cdn.magicpatterns.com/uploads/8n2eMnqpHDKhxS4cjMCqJc/Bp1.webp',
  },
  {
    title: 'Programmazione Annuale Express',
    description: 'Il metodo per organizzare l’intero anno scolastico di Scienze in poco tempo',
    price: '19 €',
    image: 'https://cdn.magicpatterns.com/uploads/gtjhPHum5CDsT7ZSqjREUv/Bp2.webp',
  },
  {
    title: 'Kit Sopravvivenza Supplenze',
    description: 'Cosa fare quando devi entrare in classe senza preparazione',
    price: '19 €',
    image: 'https://cdn.magicpatterns.com/uploads/kXY2mm5z5DKWY97Gsdc6Je/Bp3.webp',
  },
  {
    title: 'Correzione Express',
    description: 'Sistema di correzione rapida per non portarti il lavoro a casa',
    price: '19 €',
    image: 'https://cdn.magicpatterns.com/uploads/rgoGabpY486x11eLBL8U2i/Bp4.webp',
  },
  {
    title: 'Micro-Esperimenti Senza Preparazione',
    description: 'Piccoli esperimenti pronti con materiali che hai già in aula',
    price: '19 €',
    image: 'https://cdn.magicpatterns.com/uploads/52BVPQ7BdiVc8XC1ZmmrJM/Bp5.webp',
  },
]

export const bonusesTotalValue = '95 €'

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Il materiale è in formato digitale o stampabile?',
    answer:
      'Entrambi. Ogni volume è pensato per essere stampato e fotocopiato in classe, ma puoi anche usarlo in digitale su tablet o computer.',
  },
  {
    question: 'Per quali classi è adatto Biologia Pronta?',
    answer:
      'Copre tutta la scuola primaria (classi 1ª-5ª) e la secondaria di primo grado (classi 1ª-3ª), per alunni dai 6 ai 14 anni.',
  },
  {
    question: 'Il materiale segue il curricolo scolastico italiano?',
    answer:
      'Sì, i contenuti seguono le Indicazioni Nazionali per il curricolo di Scienze della scuola italiana.',
  },
  {
    question: 'Devo comprare qualcosa in più per usarlo tutto l’anno?',
    answer:
      'No, i 10 volumi coprono l’intero percorso di Scienze dalla primaria alla secondaria di primo grado, con tutte le verifiche incluse.',
  },
  {
    question: 'Quanto tempo impiego a preparare una lezione con Biologia Pronta?',
    answer: 'Le lezioni sono già pronte: ti serve solo scegliere l’unità e stampare o proiettare il materiale.',
  },
  {
    question: 'Come ricevo il materiale dopo l’acquisto?',
    answer:
      'Riceverai accesso immediato al link con tutti i file in formato PDF, pronti da scaricare e stampare.',
  },
]
